import React, { FC, useState, useRef, useEffect } from 'react'
import { isMobile } from 'react-device-detect'

import { WizzardPageBox, WizzardPhotoInfoRow } from '../style/UserWIzzardStyle'

import CheckIcon from '../../../assets/REDESIGN_Assets/UserWizzard/check_arrow.png'

import GenericInput from '../../../GenericComponents/GenericInput'
import GenericIcon from '../../../GenericComponents/GenericIcon'
import GenericTextSpan from '../../../GenericComponents/GenericTextSpan'
import GenericRow from '../../../GenericComponents/GenericRow'
import GenericButton from '../../../GenericComponents/GenericButton'

import FrontOutline from '../../../assets/REDESIGN_Assets/UserWizzard/woman_front_outline.png'
import SideOutline from '../../../assets/REDESIGN_Assets/UserWizzard/woman_side_outline.png'
import BackOutline from '../../../assets/REDESIGN_Assets/UserWizzard/woman_back_outline.png'

interface PhotoStateInterface {
  displayPhoto: string
  filePhoto: null | {}
}

interface WizzardPhotoModeInterface {
  photoOrder: number
  frontPhoto: PhotoStateInterface
  sidePhoto: PhotoStateInterface
  backPhoto: PhotoStateInterface
  handleImageUpload: Function
  handleNextButtonAction: Function
  handleNextButtonText: Function
  isEntryMode: boolean
}

const WizzardPhotoMode: FC<WizzardPhotoModeInterface> = ({
  photoOrder,
  backPhoto,
  frontPhoto,
  sidePhoto,
  handleImageUpload,
  handleNextButtonAction,
  handleNextButtonText,
  isEntryMode,
}) => {
  const addImageButtonRef: any = useRef(null)
  const [shouldShowAddPhotoButton, setShouldAddPhotoButton] = useState(true)

  useEffect(() => {
    showAddImageButton()
  }, [photoOrder, frontPhoto, backPhoto, sidePhoto])

  const handlePhotoBackground = () => {
    let photoBackground = null

    switch (photoOrder) {
      case 0:
        frontPhoto.displayPhoto
          ? (photoBackground = frontPhoto.displayPhoto)
          : (photoBackground = FrontOutline)
        break
      case 1:
        sidePhoto && sidePhoto.displayPhoto
          ? (photoBackground = sidePhoto.displayPhoto)
          : (photoBackground = SideOutline)
        break
      case 2:
        backPhoto && backPhoto.displayPhoto
          ? (photoBackground = backPhoto.displayPhoto)
          : (photoBackground = BackOutline)
        break
      default:
        break
    }

    return photoBackground
  }

  const showAddImageButton = () => {
    switch (photoOrder) {
      case 0:
        frontPhoto && frontPhoto.displayPhoto
          ? setShouldAddPhotoButton(false)
          : setShouldAddPhotoButton(true)
        break
      case 1:
        sidePhoto && sidePhoto.displayPhoto
          ? setShouldAddPhotoButton(false)
          : setShouldAddPhotoButton(true)
        break
      case 2:
        backPhoto && backPhoto.displayPhoto
          ? setShouldAddPhotoButton(false)
          : setShouldAddPhotoButton(true)
        break
      default:
        break
    }
  }

  const handleBackgroundSize = () => {
    let photoBackgroundSize = null

    switch (photoOrder) {
      case 0:
        frontPhoto.displayPhoto
          ? (photoBackgroundSize = 'contain')
          : (photoBackgroundSize = 'contain')
        break
      case 1:
        sidePhoto && sidePhoto.displayPhoto
          ? (photoBackgroundSize = 'contain')
          : (photoBackgroundSize = 'contain')
        break
      case 2:
        backPhoto && backPhoto.displayPhoto
          ? (photoBackgroundSize = 'contain')
          : (photoBackgroundSize = 'contain')
        break
      default:
        break
    }

    return photoBackgroundSize
  }

  const changeUploadImageButtonText = () => {
    let text = ''

    switch (photoOrder) {
      case 0:
        frontPhoto.filePhoto == null
          ? (text = 'Wybierz zdjęcie')
          : (text = 'Zmień zdjęcie')
        break
      case 1:
        sidePhoto.filePhoto == null
          ? (text = 'Wybierz zdjęcie')
          : (text = 'Zmień zdjęcie')
        break
      case 2:
        backPhoto.filePhoto == null
          ? (text = 'Wybierz zdjęcie')
          : (text = 'Zmień zdjęcie')
        break
      default:
        break
    }

    return text
  }

  return (
    <WizzardPageBox
      className={`wizzard-photo-upload ${isEntryMode && 'entry-mode'}`}
    >
      <GenericTextSpan fSize={'1.5rem'} margin={'0 0 3% 0'}>
        {photoOrder == 0
          ? 'Zdjęcie z przodu'
          : photoOrder == 1
          ? 'Zdjęcie z boku'
          : 'Zdjęcie z tyłu'}
      </GenericTextSpan>
      <label className="custom-file-upload">
        <GenericIcon
          src={handlePhotoBackground()}
          width={isMobile ? '100%' : '50%'}
          height={isMobile ? '50vh' : '45vh'}
          backgroundSize={handleBackgroundSize()}
        ></GenericIcon>
        <input
          ref={addImageButtonRef}
          accept="image/*"
          type="file"
          onChange={(e: any) => handleImageUpload(e, photoOrder)}
        />
        <GenericRow margin={'3% 0 0 0'}>
          {shouldShowAddPhotoButton ? (
            <GenericButton
              onClick={() => addImageButtonRef.current.click()}
              justify={'center'}
              className="with-arrow  standard"
              width={isMobile ? '90%' : '40%'}
            >
              {changeUploadImageButtonText()}
            </GenericButton>
          ) : (
            <GenericButton
              justify={'center'}
              className="with-arrow  standard"
              width={isMobile ? '90%' : '40%'}
              onClick={() => handleNextButtonAction()}
            >
              {handleNextButtonText()}
            </GenericButton>
          )}
        </GenericRow>
      </label>
    </WizzardPageBox>
  )
}

export default WizzardPhotoMode
